export default __webpack_public_path__ + "static/media/friskybunnies.0e230067.gif";